import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useUpdateUser = () => {
  const mutation = useMutation((userInfo) => {
    return axiosClient.put("/User/UpdateUser", userInfo);
  });
  return mutation;
};
export default useUpdateUser;